import { render, staticRenderFns } from "./MineGift.vue?vue&type=template&id=f7b88d7a&scoped=true"
import script from "./MineGift.vue?vue&type=script&lang=js"
export * from "./MineGift.vue?vue&type=script&lang=js"
import style0 from "./MineGift.vue?vue&type=style&index=0&id=f7b88d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b88d7a",
  null
  
)

export default component.exports